import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCampaignEmailHub } from './CampaignEmailHubContext';
import { fetchCampaignById } from '../../../api/campaigns';
import CampaignEmailTemplateEditorWizard from '../../../components/campaigns/CampaignEmailTemplateEditorWizard';
import {
  campaignEmailTemplateId,
  campaignEmailTemplatesFromCampaign,
} from '../../../utils/campaignEmailTemplate';

export default function CampaignEmailTemplateRoute() {
  const { id, templateId: templateIdParam } = useParams();
  const location = useLocation();
  const hub = useCampaignEmailHub();
  const [campaign, setCampaign] = useState(hub.campaign || null);
  const navigate = useNavigate();
  // Route dédiée …/templates/new n'expose pas :templateId (seulement :id).
  const isNew =
    templateIdParam === 'new' ||
    location.pathname.replace(/\/+$/, '').endsWith('/templates/new');

  useEffect(() => {
    if (hub.campaign) {
      setCampaign(hub.campaign);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchCampaignById(id);
        if (!cancelled) setCampaign(res?.data?.campaign || null);
      } catch (e) {
        console.error(e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, hub.campaign]);

  const initialTemplate = useMemo(() => {
    if (isNew || !campaign) return null;
    const list = campaignEmailTemplatesFromCampaign(campaign);
    return (
      list.find((t) => campaignEmailTemplateId(t) === String(templateIdParam)) || null
    );
  }, [campaign, isNew, templateIdParam]);

  if (!campaign) {
    return <p className="main-content text-sm text-muted-foreground">Chargement…</p>;
  }

  if (!isNew && !initialTemplate) {
    return (
      <p className="main-content text-sm text-destructive">
        Template introuvable.
      </p>
    );
  }

  const cid = campaign._id || campaign.id;
  const base = `/campaigns/${encodeURIComponent(cid)}/email`;

  return (
    <CampaignEmailTemplateEditorWizard
      layout="embed"
      campaign={campaign}
      initialTemplate={initialTemplate}
      onClose={() => navigate(base)}
      onSaved={() => navigate(base)}
    />
  );
}
